import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { usePreviewProvider } from 'modules/processes/components/ItemWizard/Providers/preview'
import { DataCollectionCategories } from 'modules/processes/domain'

import PreviewAttachments from '../../../../components/Preview/Attachments'
import PreviewDescription from '../../../../components/Preview/Description'
import PreviewTitle from '../../../../components/Preview/Title'
import ContractCF from './ContractCF'
import Dates from './components/Dates'
import RolesLevel from './components/RolesLevel'
import Salary from './components/Salary'
import WorkingHours from './components/WorkingHours'

const ALLOWED_CATEGORIES = [
  DataCollectionCategories.start_date,
  DataCollectionCategories.role,
  DataCollectionCategories.salary,
  DataCollectionCategories.contract_hours,
]

const COMPONENTS = {
  [DataCollectionCategories.start_date]: <Dates />,
  [DataCollectionCategories.role]: <RolesLevel />,
  [DataCollectionCategories.salary]: <Salary />,
  [DataCollectionCategories.contract_hours]: <WorkingHours />,
}

const Preview = () => {
  const { previewValues } = usePreviewProvider()
  const selectedCategories = previewValues.selectedCategories.filter(
    (category: string) => !category.includes('-')
  )
  const categories = ALLOWED_CATEGORIES.filter((category) => selectedCategories.includes(category))

  const title = (cat: DataCollectionCategories) => {
    switch (cat) {
      case DataCollectionCategories.start_date:
        return i18n.t(
          'processes.process_settings.wizard.tasks.types.contract_data.preview.start_date.title'
        )
      case DataCollectionCategories.role:
        return i18n.t(
          'processes.process_settings.wizard.tasks.types.contract_data.preview.role.title'
        )
      case DataCollectionCategories.salary:
        return i18n.t(
          'processes.process_settings.wizard.tasks.types.contract_data.preview.salary.title'
        )
      case DataCollectionCategories.contract_hours:
        return i18n.t(
          'processes.process_settings.wizard.tasks.types.contract_data.preview.contract_hours.title'
        )
      case DataCollectionCategories.contract_custom_fields:
        return i18n.t(
          'processes.process_settings.wizard.tasks.types.contract_data.preview.contract_custom_fields.title'
        )
      default:
        return ''
    }
  }

  return (
    <Box>
      <PreviewTitle />
      <PreviewDescription />
      <PreviewAttachments />

      <Box paddingTop="s16" paddingBottom="s8">
        <Text.Normal weight="semibold" color="grey1000">
          {i18n.t('processes.process_settings.wizard.tasks.types.request_id.preview.title')}
        </Text.Normal>

        <Box paddingTop="s8">
          <Text.Normal>
            {i18n.t(
              'processes.process_settings.wizard.tasks.types.contract_data.preview.description'
            )}
          </Text.Normal>
        </Box>
      </Box>
      {!!selectedCategories.length &&
        categories.map((category) => (
          <Box gap="s8" key={category} paddingBottom="s8">
            <Text.Normal size="300" color="grey800" weight="medium">
              {title(category)}
            </Text.Normal>
            <Box
              key={category}
              padding="s24"
              gap="s24"
              background="grey200"
              borderRadius={{ all: 'abs008' }}
            >
              {COMPONENTS[category as keyof typeof COMPONENTS]}
            </Box>
          </Box>
        ))}
      <ContractCF />
    </Box>
  )
}

export default Preview
